import { createAction } from 'redux-actions';

import {
  UPLOAD_STARTED,
  UPLOAD_PROGRESS,
  UPLOAD_FINISHED,
  CHECKOUT_STARTED,
  CHECKOUT_FINISHED
} from '../config/const';

export const uploadStart = createAction(UPLOAD_STARTED);
export const uploadFinish = createAction(UPLOAD_FINISHED);
export const checkoutStart = createAction(CHECKOUT_STARTED);
export const checkoutFinish = createAction(CHECKOUT_FINISHED);
export const uploadProgress = createAction(UPLOAD_PROGRESS);

const initialState = {
  inProgress: false,
  progress: null,
  checkoutProgress: false
};

const uploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECKOUT_STARTED:
      return {
        ...state,
        checkoutProgress: true
      };
    case CHECKOUT_FINISHED:
      return {
        ...state,
        checkoutProgress: false
      };
    case UPLOAD_STARTED:
      return {
        ...state,
        inProgress: true,
        progress: 0
      };
    case UPLOAD_FINISHED:
      return {
        ...state,
        inProgress: false,
        progress: null
      };
    case UPLOAD_PROGRESS:
      return {
        ...state,
        progress: action.payload
      };
    default:
      return state;
  }
};

export default uploadReducer;



// WEBPACK FOOTER //
// ./src/reducers/uploadReducer.js